import React from "react";
import { Collapsible, CollapsibleContent } from "@/components/ui/collapsible";
import { NearbyPanel } from "@/components/units/unit/info/NearbyPanel";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";

interface NearbyCollapseProps {
    isOpen: boolean;
    onToggle: () => void;
    children: React.ReactNode;
    className: string;
    dataAttributes: object;
}

export const NearbyCollapse = ({
    isOpen,
    onToggle,
    children,
    className,
    dataAttributes,
}: NearbyCollapseProps) => {
    const { unitGroup } = useUnitItemContext();

    return (
        <Collapsible
            open={isOpen}
            onOpenChange={onToggle}
            className={className}
            {...dataAttributes}
        >
            {children}
            <CollapsibleContent className="unit-item__nearby unit-item__nearby-collapse-content tw:flex tw:flex-wrap tw:w-full">
                <NearbyPanel unitGroup={unitGroup} />
            </CollapsibleContent>
        </Collapsible>
    );
};
